import './instagram_message_ticket_response_view.js.coffee'

Namespace 'Customer.Dashboard'

class Customer.Dashboard.InstagramCommentTicketResponseView extends
Customer.Dashboard.InstagramMessageTicketResponseView

  _handleResponseError: (response) ->
    if response.error_type == 'instagram_content_not_answerable'
      @_handleInstagramContentNotAnswerable()
      @_enableResponse()
    else if response.error_type == 'already_replied_public_instagram_comment_error'
      showError(I18n.t('customer.dashboard.errors.already_replied_public_instagram_comment_error'))
      @_enableResponse()
    else
      super(response)

  _handleInstagramContentNotAnswerable: ->
    swal({
      title: I18n.t('customer.dashboard.errors.instagram_comment_public_reply.title')
      text: I18n.t('customer.dashboard.errors.instagram_comment_public_reply.text')
      type: 'error'
      showConfirmButton: false
    })
    @$el.find('button[value="public"]').click()
    @attachment.clearAllAttachments()
    @_enableResponseTextArea()

  _checkInstagramCommentReply: ->
    return true unless @isPrivate

    interactionToReply = @ticket.getInteractionById(@responseTo)
    now = moment()
    creationDate = moment(interactionToReply.created_at())
    daysBetween = moment.duration(now.diff(creationDate)).asDays()
    return true if !interactionToReply.isAd() && daysBetween < 7

    @_handleInstagramContentNotAnswerable()
    false

  _canReply: ->
    @_checkInstagramCommentReply() && super()

  onPrivateSuccessful: =>
    super()
    @_showSticker()
    @_toggleAttachmentsContainer(false)

  onPublic: =>
    super()
    @_hideSticker()
    @_toggleAttachmentsContainer(true)

  _toggleAttachmentsContainer: (shouldBeHidden) ->
    @$el.find('.attachment-uploader').toggleClass('d-none', shouldBeHidden)

  _doCheckValidResponse: (comment, type, publicOrPrivate) =>
    return if publicOrPrivate == 'private'
    @_checkValidNumberOfUrls(comment)
    @_checkValidNumberOfHashtags(comment)
    @_checkNotAllUppercase(comment)

  _checkValidNumberOfUrls: (comment) ->
    arrayOfUrls = comment.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig)
    if (arrayOfUrls != null and arrayOfUrls.length > 1)
      throw new Error('Instagram comments cannot contain more than 1 URL.')

  _checkValidNumberOfHashtags: (comment) ->
    arrayOfHashtags = comment.match(/#\S+/g)
    if (arrayOfHashtags != null and arrayOfHashtags.length > 4)
      throw new Error('Instagram comments cannot contain more than 4 hashtags.')

  _checkNotAllUppercase: (comment) ->
    if comment == comment.toUpperCase()
      throw new Error('Instagram comments cannot consist of all capital letters.')

  _checkValidInstagramAPI: ->
    true

  _renderStickerIcon: ->
    super()
    @_hideSticker() unless @isPrivate

  _hideSticker: ->
    @currentSticker?.destroy()
    @$el.find('.add_sticker').addClass('hidden')

  _showSticker: ->
    @$el.find('.add_sticker').removeClass('hidden')
